<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-large">

            <div class="uk-modal-header">
                <h4 class="uk-margin-remove uk-text-danger">해외주문정보 삭제</h4>
            </div>

            <div class="uk-modal-body uk-padding-small" >


                <app-column
                    header="번호"
                    header-size="medium"
                    body-size="medium"
                    header-align="left"
                    body-align="left"
                    horizontal
                    header-width="100px"
                >
                    {{ order.id }}
                </app-column>

                <app-column
                    header="회원사"
                    header-size="medium"
                    body-size="medium"
                    header-align="left"
                    body-align="left"
                    horizontal
                    header-width="100px"
                >
                    {{ order.user_nick }}
                </app-column>

                <app-column
                    header="해외주문번호"
                    header-size="medium"
                    body-size="medium"
                    header-align="left"
                    body-align="left"
                    horizontal
                    header-width="100px"
                >
                    {{ order.buy_order_code }}
                </app-column>

            </div>


            <div class="uk-modal-footer uk-text-right">
                <!-- 컨펌메세지 -->
                <div class="uk-margin-bottom">
                    정말 삭제합니까?
                </div>

                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>
                <button
                    type="button"
                    class="uk-button uk-button-danger"
                    v-on:click="submit()"
                >
                    <span uk-icon="icon: check"></span>
                    삭제(완료)
                </button>
            </div>
        </div>
    </div>
</template>

<script>


    export default {
        props: {
            // csrf-token
            csrfToken: String,

            // 완료 후 이동할 페이지
            moveTo: {
                type: String,
                default: null,
            }
        },
        data: function () {
            return {

                /**
                 * (object) 오더정보
                 */
                order: {},
            };
        },
        computed: {

        },
        methods: {
            /**
             * 입력폼 display
             */
            displayForm() {
                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             */
            form(order_id) {

                //  조회하기
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/buy-orders/'+order_id,
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((response) => {
                    this.order = response.order;

                    // 폼띄우기
                    this.displayForm();
                });



            },

            /**
             * submit
             */
            submit() {

                // ajax 옵션
                let opts = {
                    type: 'delete',
                    url: '/buy-orders/' + this.order.id,
                    data: {
                        '_token': this.csrfToken,
                    },

                    success: (response, textStatus, jqXHR) => {
                        UIkit.modal.alert(response.msg).then(() => {
                            $.app.move(this.moveTo);
                        });
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>